import { Box, useColorModeValue } from "@chakra-ui/react";
import type React from "react";

type Props = { children: React.ReactNode };

const SidebarDesktop = ({ children }: Props) => {
  const bg = useColorModeValue("#FFF", "gray.900");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  
  return (
    <Box 
      width={"max-content"} 
      flexShrink={0} 
      bgColor={bg}
      borderRight="1px solid"
      borderColor={borderColor}
      boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)"
      zIndex={10}
    >
      {children}
    </Box>
  );
};

export default SidebarDesktop;
